import { useState, useEffect } from 'react';
import axios from 'axios';

const API = '/api';

export function useShortcuts() {
  const [shortcuts, setShortcuts] = useState<{id: number, name: string, text: string}[]>([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [suggestions, setSuggestions] = useState<{id: number, name: string, text: string}[]>([]);

  const fetchShortcuts = () => {
    // Jak w Settings (dziala): axios.get bez jawnego tokenu z localStorage — uzywa
    // globalnego naglowka axios (w pamieci), odpornego na blokade localStorage i timing.
    axios.get(API + '/shortcuts')
      .then(r => setShortcuts(r.data.shortcuts || []))
      .catch(() => {});
  };
  useEffect(() => {
    fetchShortcuts();
  }, []);

  const handleChange = (
    newValue: string,
    setValue: (v: string) => void
  ) => {
    setValue(newValue);
    const match = newValue.match(/#(\w*)$/);
    if (match) {
      // Jesli skroty nie zostaly jeszcze pobrane (np. pierwsze pobranie zawiodlo na timingu),
      // dociagnij je teraz — user wlasnie ich potrzebuje.
      if (shortcuts.length === 0) fetchShortcuts();
      const q = match[1].toLowerCase();
      const filtered = q.length === 0
        ? shortcuts
        : shortcuts.filter(s => s.name.toLowerCase().startsWith(q));
      setSuggestions(filtered);
      setShowSuggestions(filtered.length > 0);
    } else {
      setShowSuggestions(false);
    }
  };

  const applyShortcut = (
    shortcut: {name: string, text: string},
    value: string,
    setValue: (v: string) => void
  ) => {
    const newValue = value.replace(/#\w*$/, shortcut.text);
    setValue(newValue);
    setShowSuggestions(false);
  };

  return { showSuggestions, suggestions, handleChange, applyShortcut, setShowSuggestions };
}
